import { TEMPLATE_LIST } from 'lorena-templates'
import { X } from 'lucide-react'
import { SlidePreviewFrame } from './SlidePreviewFrame'

interface Props {
  onPick: (templateId: string) => void
  onClose: () => void
}

export function TemplatePickerModal({ onPick, onClose }: Props) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
        <div className="modal-header">
          <h2>Escolher template</h2>
          <button type="button" className="secondary icon-button" onClick={onClose} aria-label="Fechar">
            <X size={16} />
          </button>
        </div>
        <div className="template-grid">
          {TEMPLATE_LIST.map((template) => (
            <button key={template.id} type="button" className="template-card secondary" onClick={() => onPick(template.id)}>
              <div className="template-card__thumb">
                <SlidePreviewFrame
                  templateId={template.id}
                  content={template.previewContent}
                  ctx={template.previewCtx}
                  displayWidth={140}
                />
              </div>
              <span className="template-card__label">{template.label}</span>
              <span className="template-card__tags">
                {template.tags.map((tag) => (
                  <span key={tag} className="tag-chip">
                    {tag}
                  </span>
                ))}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
